module.exports = __webpack_public_path__ + "fonts/Gilroy-Regular.d7c5d3f.woff";